module.exports = __webpack_public_path__ + "static/media/plaza-3.d9ec0471.webp";